import { Select } from '@pankod/refine-antd';
import { useFeatureFlag } from 'hooks/useFeatureFlags';
import { useEffect, useState } from 'react';
import { getInvoiceProfiles } from 'services/invoice-profile';
import { chooseInitialInvoiceProfileId, IInvoiceProfile } from 'utilities/invoice-profile';

type InvoiceProfileSelectProps = {
  value?: string;
  onChange?: (invoiceProfileId: string | undefined) => void;
  style?: React.CSSProperties;
};

// Aziz Auto A4: the invoice header a sale is billed under, with the default preselected. Hidden
// while `sale.invoiceProfiles` is off or no header exists, so the sale prints the company header.
export const InvoiceProfileSelect: React.FC<InvoiceProfileSelectProps> = ({
  value,
  onChange,
  style,
}) => {
  const invoiceProfilesEnabled = useFeatureFlag('sale.invoiceProfiles');
  const [profiles, setProfiles] = useState<IInvoiceProfile[]>([]);

  useEffect(() => {
    if (!invoiceProfilesEnabled) return;
    getInvoiceProfiles()
      .then((loadedProfiles) => {
        setProfiles(loadedProfiles);
        if (!value) onChange?.(chooseInitialInvoiceProfileId(loadedProfiles));
      })
      .catch(() => setProfiles([]));
    // Load once when the feature turns on; the default is applied only if nothing is chosen.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceProfilesEnabled]);

  if (!invoiceProfilesEnabled || !profiles.length) return null;

  return (
    <Select
      style={style}
      value={value}
      onChange={(selected: string) => onChange?.(selected)}
      options={profiles.map((profile) => ({
        value: profile.id,
        label: profile.isDefault ? `${profile.label} (default)` : profile.label,
      }))}
    />
  );
};
